import uniqueIds from '@/config/unique-ids.json'
import icLogo from '@/assets/logo.svg'
import hsmsfLogo from '@/assets/hsmsf/h-logo.png'
import pgqjywyhLogo from '@/assets/pgqjywyh/logo.svg'
import zhzxjsLogo from '@/assets/zhzxjs/logo.svg'
import szyjxyLogo from '@/assets/szyjxy/logo.svg'

import { jumpConfig } from './jump'
import { LoginLeftConfig } from './login-left'
import { LoginRightConfig } from './login-right'

import { getUniqueId } from './common'

export { getUniqueId }

const totalConfig = {
  test: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: 'FEIXIANG_UNIQUE_ID',
    [uniqueIds.HSMSF_UNIQUE_ID.id]: 'HSMSF_UNIQUE_ID',
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: 'PGQJYWYH_UNIQUE_ID',
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: 'ZHZXJS_UNIQUE_ID',
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: 'JIANGUAN_UNIQUE_ID',
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: 'SUZHOUYIJIAXUEYUAN_UNIQUE_ID',
  },
  logoSrc: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: icLogo,
    [uniqueIds.HSMSF_UNIQUE_ID.id]: hsmsfLogo,
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: pgqjywyhLogo,
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: zhzxjsLogo,
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: icLogo,
    [uniqueIds.FLYING_UNIQUE_ID.id]: icLogo,
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: szyjxyLogo,
  },
  logoHeight: {
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: 30,
  },
  companyPrefix: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: '/',
    [uniqueIds.HSMSF_UNIQUE_ID.id]: '/hsmsf',
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: '/pgqjywyh',
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: '/zhzxjs',
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: '/jianguan',
    [uniqueIds.FLYING_UNIQUE_ID.id]: '/flying',
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: '/szyjxy',
  },
  defaultRedirectFeixiangProd: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: 'https://ke.feixiangxingqiu.com',
    [uniqueIds.HSMSF_UNIQUE_ID.id]: 'https://laoshi.feixiangxingqiu.com/hsmsf',
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: 'https://laoshi.feixiangxingqiu.com/pgqjywyh',
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: 'https://laoshi.feixiangxingqiu.com/zhzxjs',
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: 'https://jianguan.feixiangxingqiu.com',
    [uniqueIds.FLYING_UNIQUE_ID.id]: 'https://shouji.feixiangxingqiu.com',
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: 'https://laoshi.feixiangxingqiu.com/szyjxy/#/thoth/home',
  },
  defaultRedirectTop100Prod: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: 'https://mapi.top100school.com/lectio/#/home',
    [uniqueIds.HSMSF_UNIQUE_ID.id]: 'https://mapi.top100school.com/lectio/#/home',
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: 'https://mapi.top100school.com/lectio/#/home',
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: 'https://mapi.top100school.com/lectio/#/home',
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: 'https://mapi.top100school.com/lectio/#/home',
    [uniqueIds.FLYING_UNIQUE_ID.id]: 'https://mapi.top100school.com/lectio/#/home',
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: 'https://mapi.top100school.com/lectio/#/home',
  },
  defaultRedirectFeixiangTest: {
    [uniqueIds.FEIXIANG_UNIQUE_ID.id]: 'https://ke.feixiangxingqiu.biz',
    [uniqueIds.HSMSF_UNIQUE_ID.id]: 'https://laoshi.feixiangxingqiu.biz/hsmsf',
    [uniqueIds.PGQJYWYH_UNIQUE_ID.id]: 'https://laoshi.feixiangxingqiu.biz/pgqjywyh',
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: 'https://laoshi.feixiangxingqiu.biz/zhzxjs',
    [uniqueIds.JIANGUAN_UNIQUE_ID.id]: 'https://jianguan.feixiangxingqiu.biz',
    [uniqueIds.FLYING_UNIQUE_ID.id]: 'https://shouji.feixiangxingqiu.biz',
    [uniqueIds.SUZHOUYIJIAXUEYUAN_UNIQUE_ID.id]: 'https://laoshi.feixiangxingqiu.biz/szyjxy/#/thoth/home',
  },
  saveTokenToStorageWhenInitData: {
    [uniqueIds.ZHZXJS_UNIQUE_ID.id]: true,
  },
}

type UNIQUE_ID_TYPE = keyof (typeof uniqueIds)
type UNIQUE_ID_TYPE_VALUE = typeof uniqueIds[UNIQUE_ID_TYPE]['id']

const tempTotal: {
  [k in keyof (typeof totalConfig)]: (typeof totalConfig)[k][UNIQUE_ID_TYPE_VALUE];
} = {} as any

const jumpTotal: {
  [k in keyof (typeof jumpConfig)]: (typeof jumpConfig)[k][UNIQUE_ID_TYPE_VALUE];
} = {} as any

const loginRightTotal: {
  [k in keyof (typeof LoginRightConfig)]: (typeof LoginRightConfig)[k][UNIQUE_ID_TYPE_VALUE];
} = {} as any

const loginLeftTotal: {
  [k in keyof (typeof LoginLeftConfig)]: (typeof LoginLeftConfig)[k][UNIQUE_ID_TYPE_VALUE];
} = {} as any

defineConfig(totalConfig, tempTotal)
defineConfig(jumpConfig, jumpTotal)
defineConfig(LoginRightConfig, loginRightTotal)
defineConfig(LoginLeftConfig, loginLeftTotal)

function defineConfig(origin: any, target: any) {
  Object.keys(origin).forEach((key) => {
    // eslint-disable-next-line no-prototype-builtins
    if (origin.hasOwnProperty(key)) {
      Object.defineProperty(target, key, {
        configurable: false,
        enumerable: true,
        value: origin[key][getUniqueId()],
        writable: false,
      })
    }
  })
}

export const ProjectConfig = {
  ...jumpTotal,
  ...tempTotal,
  loginLeft: loginLeftTotal,
  loginRight: loginRightTotal,
}
